import * as Sentry from '@sentry/react';
import { config } from './config';

function isBlacklistedBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return ua.includes('Electron') || ua.includes('HeadlessChrome');
}

Sentry.init({
  dsn: 'https://8fe128eecbc93ca6d6d2d6a004b09d5d@o356571.ingest.us.sentry.io/4508222310580224',
  environment: config.Environment,
  release: 'messenger@0.1.0',
  integrations: [Sentry.replayIntegration()],

  tracesSampleRate: 0.0,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event) {
    if (isBlacklistedBrowser() || process.env.NODE_ENV !== 'production') return null;
    return event;
  }
});
